import styled from 'styled-components'

export const QuestionAnswerWrapper = styled.div`
    border-top: 1px solid var(--primary-color);
    padding: 15px;
    margin: 5px -15px;
`
